var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 10.5V31.5C6.5625 32.1962 6.83906 32.8639 7.33134 33.3562C7.82363 33.8484 8.49131 34.125 9.1875 34.125H35.4375C35.7856 34.125 36.1194 33.9867 36.3656 33.7406C36.6117 33.4944 36.75 33.1606 36.75 32.8125V14.4375C36.75 14.0894 36.6117 13.7556 36.3656 13.5094C36.1194 13.2633 35.7856 13.125 35.4375 13.125H9.1875C8.49131 13.125 7.82363 12.8484 7.33134 12.3562C6.83906 11.8639 6.5625 11.1962 6.5625 10.5ZM6.5625 10.5C6.5625 9.80381 6.83906 9.13613 7.33134 8.64384C7.82363 8.15156 8.49131 7.875 9.1875 7.875H31.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5312 24.9375C30.2561 24.9375 30.8438 24.3499 30.8438 23.625C30.8438 22.9001 30.2561 22.3125 29.5312 22.3125C28.8064 22.3125 28.2188 22.9001 28.2188 23.625C28.2188 24.3499 28.8064 24.9375 29.5312 24.9375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.f3db6730ab9a187e6e0d1969cae35523.svg";
export { ForwardRef as ReactComponent };